import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import { reduxForm, Form, Field } from 'redux-form/immutable'

import { FORM_ID, FIELD, EMAIL_REGEX, LOCALE_PREFIX } from './constants'

import Input from '../../../../../../../../../Form/components/Input'
import Button from '../../../../../../../../../Form/components/Button'

import hocConnect from './hocConnect'

import './style.scss'

function validate(values, props) {
    const errors = {}

    const firstName = values.get(FIELD.FIRST_NAME)
    if (!firstName)
        errors[FIELD.FIRST_NAME] = props.intl.formatMessage({ id: `${LOCALE_PREFIX}.message.error.firstName` })

    const lastName = values.get(FIELD.LAST_NAME)
    if (!lastName) errors[FIELD.LAST_NAME] = props.intl.formatMessage({ id: `${LOCALE_PREFIX}.message.error.lastName` })

    const email = values.get(FIELD.EMAIL)
    if (!email) errors[FIELD.EMAIL] = props.intl.formatMessage({ id: `${LOCALE_PREFIX}.message.error.email` })
    if (!EMAIL_REGEX.test(email))
        errors[FIELD.EMAIL] = props.intl.formatMessage({ id: `${LOCALE_PREFIX}.message.error.emailFormat` })

    return errors
}

@injectIntl
@hocConnect
@reduxForm({ form: FORM_ID, touchOnChange: true, validate })
export default class EditProfileForm extends Component {
    static propTypes = {
        anyTouched: PropTypes.bool.isRequired,
        contentId: PropTypes.string.isRequired,
        error: PropTypes.string,
        handleSubmit: PropTypes.func.isRequired,
        intl: PropTypes.object.isRequired,
        invalid: PropTypes.bool.isRequired,
        pristine: PropTypes.bool.isRequired,
        submitDataForm: PropTypes.func.isRequired,
        submitSucceeded: PropTypes.bool.isRequired,
        submitting: PropTypes.bool.isRequired,
        untouch: PropTypes.func.isRequired,
    }

    onSubmit = (values) => {
        const { contentId, submitDataForm, untouch } = this.props

        submitDataForm(contentId, values)
        untouch(FIELD.FIRST_NAME, FIELD.LAST_NAME, FIELD.EMAIL)
    }

    render() {
        const { error, intl, handleSubmit, anyTouched, pristine, submitting, submitSucceeded, invalid } = this.props

        return (
            <Form className={'edit-profile-form'} onSubmit={handleSubmit(this.onSubmit)}>
                <div className={'name'}>
                    <div className={'firstName'}>
                        <Field
                            name={FIELD.FIRST_NAME}
                            component={Input}
                            label={intl.formatMessage({ id: `${LOCALE_PREFIX}.firstName.label` })}
                            placeholder={intl.formatMessage({ id: `${LOCALE_PREFIX}.firstName.placeholder` })}
                            disabled={submitting}
                        />
                    </div>
                    <div className={'lastName'}>
                        <Field
                            name={FIELD.LAST_NAME}
                            component={Input}
                            placeholder={intl.formatMessage({ id: `${LOCALE_PREFIX}.lastName.placeholder` })}
                            disabled={submitting}
                        />
                    </div>
                </div>
                <div className={'email'}>
                    <Field
                        name={FIELD.EMAIL}
                        component={Input}
                        label={intl.formatMessage({ id: `${LOCALE_PREFIX}.email.label` })}
                        placeholder={intl.formatMessage({ id: `${LOCALE_PREFIX}.email.placeholder` })}
                        disabled={submitting}
                    />
                </div>
                <div className={'submit'}>
                    <div className={'messages'}>
                        {error && (
                            <div className={'error'}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.message.error.${error}`} />
                            </div>
                        )}
                        {!anyTouched && pristine && submitSucceeded && (
                            <div className={'success'}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.message.success`} />
                            </div>
                        )}
                    </div>
                    <div className={'submit-button'}>
                        <Button
                            text={intl.formatMessage({ id: `${LOCALE_PREFIX}.submitButton` })}
                            disabled={(invalid && !error) || pristine || submitting}
                            type={'text'}
                        />
                    </div>
                </div>
            </Form>
        )
    }
}
